import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
//import { Router } from "@angular/router";
import { InvoiceService } from "src/app/services/http/business/invoice/invoice.service";
import { PaymentService } from "src/app/services/http/business/payment/payment.service";
import { InvoiceSummaryComponent } from "../../finance/payment/invoice-summary/invoice-summary.component";

@Component({
  selector: "app-placement-payment",
  templateUrl: "./placement-payment.component.html",
  styleUrls: ["./placement-payment.component.css"]
})
export class PlacementPaymentComponent implements OnInit {
  constructor(
    //private router: Router,
    private dialog: MatDialog,
    private payService: PaymentService,
    public translate: TranslateService,
    private invoiceService: InvoiceService,
    private dialogRef: MatDialogRef<PlacementPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() { }

  onPayment() {
    this.dialogRef.close();
    this.invoiceService.invoiceCompanyGetById(this.data).subscribe(res => {
      if (res.DataList[0].Price == 0) {
        this.payService.pay(this.data, 'melli').subscribe(() => {
          this.dialogRef.close();
          //this.router.navigate(["management/finance/invoice"]);
        });
      } else {
        this.dialog.open(InvoiceSummaryComponent, {
          width: '98%',
          data: { Id: this.data }
        })
          .afterClosed()
          .subscribe(() => {
            this.dialogRef.close();
          });
        // this.router.navigate([
        //   "management/finance/invoiceSummary/" + this.data
        // ]);
      }
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
